<!--
 * @description: 查看大图
 * @fileName: index.vue
 * @author: panlua
 * @date: 2019-06-18 10:38:40
 * @version: V1.0.0
!-->
<template>
  <div class="image-preview-container"
       v-if="isShow">
    <p class="header"
       v-elDrag="{moveEl: '.image-preview-container'}">
      {{ $t('business.button.capture') }}
      <i class="el-icon-close"
         @click="close"></i>
    </p>
    <div class="image-container">
      <!-- <vue-cropper v-if="showCropper"
                   ref="cropper"
                   :img="dataImg"
                   :outputSize="option.size"
                   :canScale="false"
                   :canMove="false"
                   :outputType="option.outputType" /> -->
    </div>
    <p class="footer">
      <i class="iconfont icon-webicon311 enlarge"
         :title="$t('business.button.zoom')"
         @click="changeImg"></i>
    </p>
  </div>
</template>

<script>
// import vueCropper from 'vue-cropper'
import { api } from '../../api'
import { Cache } from '$utils'

export default {
  components: {
    // vueCropper
  },
  data() {
    return {
      showCropper: false,
      isTailor: false, // 是否裁剪
      dataImg: null,
      isShow: false,
      option: {
        size: 1,
        outputType: 'png'
      },
      imgFileId: ''
    }
  },
  methods: {
    close() {
      this.isShow = false
      this.dataImg = null
    },
    start() {
      this.isTailor = true
      this.$refs['cropper'].startCrop()
    },
    clear() {
      this.isTailor = false
      this.$refs['cropper'].clearCrop()
    },
    getBase64Image(img) {
      let canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
      let dataURL = canvas.toDataURL('image/' + ext)
      return dataURL
    },
    loadImg(item) {
      let self = this
      let img = new Image()
      img.src = this.imgPath(item)
      img.onload = function() {
        self.showCropper = true
        self.dataImg = self.getBase64Image(img)
      }
    },
    open(item) {
      //   this.dataImg = null
      //   this.imgFileId = fileId
      this.loadImg(item)
      this.isShow = true
    },
    imgPath(item) {
      const token = Cache.get('access_token')
      let url = ''
      let imageType = 1
      let type = 3
      // 人员黑名单 人员白名单时，访问告警大图参数
      if (item.alarmType === '50102' || item.alarmType === '50103') {
        imageType = 1
        type = 3
      } else if (item.alarmType === '50101') {
        // 车辆黑名单时，访问告警大图参数
        imageType = 2
        type = 1
      }
      switch (item.picResourceType) {
        // 手动告警图片时,picResourceType为1
        case 1:
          url = `${api.bas.picStreamInfo}?resourceCode=${
            item.resourceCode
          }&ticket=${token}`
          break
        // 联动图片时,picResourceType为3
        case 3:
          url = `${api.bas.picStreamInfo}?alarmId=${item.alarmId}&alarmType=${
            item.alarmType
          }&deviceId=${item.deviceId}&picResourceType=${
            item.picResourceType
          }&ticket=${token}`
          break
        // 抓拍图片时,picResourceType为4
        case 4:
          url = `/bas/safeEvent/getPictureStream.json?fileId=${
            item.fileId
          }&imageType=${imageType}&ticket=${token}&type=${type}&vcmSiId=${
            Cache.get('VCM_INFO').vcmPlatCode
          }`
          // url = Bus.getFacePictureStream(item.fileId, 3);
          break
        default:
          url = `${api.bas.picStreamInfo}?picResourceType=${
            item.picResourceType
          }&alarmType=${this.currentAlarmDetail.alarmType}&alarmId=${
            this.currentAlarmDetail.alarmId
          }&ticket=${token}&resourceCode=${item.resourceCode}`
      }

      return url
    },
    controlClick() {
      let self = this
      if (self.isTailor) {
        self.$refs.cropper.stopCrop()
        self.$refs.cropper.getCropData(data => {
          self.$emit('fastControl', {
            file: data
          })
        })
      } else {
        self.$emit('fastControl', {
          file: self.dataImg
        })
      }
    },
    closeClick() {
      this.isShow = false
    },
    dragStart(e) {
      e.dataTransfer.dropEffect = 'link'
      this.startX = e.screenX
      this.startY = e.screenY
    },
    dragEnd(e) {
      this.endX = e.screenX
      this.endY = e.screenY
      this.left = this.moveX
      this.top = this.moveY
    },
    /*
     *@name: 放大全屏查看
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-06-27 10:52:53
     */
    changeImg() {
      let el = document.documentElement
      let img = document.querySelector(
        '.vue-cropper .cropper-box .cropper-box-canvas img'
      )
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen
      if (typeof rfs !== 'undefined' && rfs) {
        rfs.call(img)
      }
      this.$emit('hideOption')
    }
  }
}
</script>


<style lang="scss">
.image-preview-container {
  position: fixed;
  width: 500px;
  height: 360px;
  background-color: #23365d;
  left: 50%;
  transform: translateX(-50%);
  top: 300px;
  .header {
    font-size: 14px;
    margin-bottom: 0;
    line-height: 38px;
    padding: 0 10px;
    i {
      float: right;
      cursor: pointer;
      margin-top: 6px;
      padding: 5px;
    }
  }
  .el-dialog__header {
    padding-top: 10px;
    .el-dialog__title {
      line-height: 12px;
      font-size: 15px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .title {
    font-size: 14px;
    line-height: 40px;
    padding: 0 10px;
    margin: 0;
    i {
      float: right;
      cursor: pointer;
      line-height: 40px;
    }
  }
  .image-container {
    // width: 500px;
    height: 282px;
    .image {
      /*width: 100%;*/
      height: 100%;
    }
  }
  .footer {
    font-size: 14px;
    line-height: 40px;
    padding: 0 10px;
    margin: 0;
    i {
      cursor: pointer;
    }
    button {
      margin-left: 10px;
    }
    .enlarge {
      float: right;
    }
  }
  .vue-cropper {
    background-image: none;
    .cropper-box {
      background-color: #23365d !important;
    }
  }
}
</style>

